module.exports = __webpack_public_path__ + "static/img/icon-favourite copy.5b0d5bf.png";